export const CHAT_EXECUTION_TABLE = "chatExecutions"
export const CHAT_EXECUTION_TABLE_SCHEMA =
  "id, sessionId, companyId, userId, status, syncId, createdAt"
